type TelegramHaptic = {
  impactOccurred(style: "light" | "medium" | "heavy"): void;
  notificationOccurred(type: "error" | "success" | "warning"): void;
  selectionChanged(): void;
};

type TelegramWindow = Window & {
  Telegram?: {
    WebApp?: {
      HapticFeedback?: TelegramHaptic;
    };
  };
};

export class Haptics {
  #enabled = true;
  #lastTapAt = 0;

  setEnabled(enabled: boolean): void {
    this.#enabled = enabled;
  }

  tap(): void {
    const now = performance.now();
    if (!this.#enabled || now - this.#lastTapAt < 55) return;
    this.#lastTapAt = now;
    this.#telegram()?.impactOccurred("light");
    if (this.#telegram() === undefined) navigator.vibrate?.(8);
  }

  selection(): void {
    if (!this.#enabled) return;
    this.#telegram()?.selectionChanged();
  }

  success(): void {
    if (!this.#enabled) return;
    this.#telegram()?.notificationOccurred("success");
    if (this.#telegram() === undefined) navigator.vibrate?.([12, 35, 18]);
  }

  error(): void {
    if (!this.#enabled) return;
    this.#telegram()?.notificationOccurred("error");
    if (this.#telegram() === undefined) navigator.vibrate?.([20, 25, 20]);
  }

  #telegram(): TelegramHaptic | undefined {
    return (window as TelegramWindow).Telegram?.WebApp?.HapticFeedback;
  }
}
